import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger as obsLogger } from '@fiverr-private/obs';

/**
 * Create logger by level
 * @param {string} level Log level: eg. info, warn, error.
 * @returns
 */
const log =
    (level) =>
    /**
     * Send log
     * @param {string} message Log message
     * @param {object} data Log data
     */
    (message, data = {}) => {
        const { url, userGuid, pageCtxId } = getContext();

        const payload = merge({}, data, {
            meta: {
                url,
                userGuid,
                pageCtxId,
            },
        });

        obsLogger[level](message, payload);
    };

export const logger = {
    info: log('info'),
    error: log('error'),
};
